import { manageDataRoute } from "../routes/routeConstants";
import { MANAGE_DATA_PERMISSIONS } from "./permissions";

export const MANAGE_DATA_TABS = [
  { label: "Review Batches", value: manageDataRoute.reviewBatches },
  {
    label: "Copied Batches",
    value: manageDataRoute.copyHistory,
    permission: MANAGE_DATA_PERMISSIONS.VIEW_COPIED_BATCHES,
  },
  {
    label: "Upload Summary",
    value: manageDataRoute.reviewList,
    permission: MANAGE_DATA_PERMISSIONS.VIEW_BATCH_LIST,
  },
];
